import type { MPLOffer, MPLPreApprovalOffer } from 'commonTypes/api/scenarios/CreditSelectionScreenContent';

import { isMplOffer, isMplPreApprovalOffer } from 'shared/lib';
import type { TOffer } from 'shared/types/TRankingService';

export const getAnalyticsBadgesParam = (offer: TOffer | MPLOffer | MPLPreApprovalOffer) => {
  if (isMplOffer(offer) || isMplPreApprovalOffer(offer)) {
    return (offer.badges || []).map((b) => b.title).join(' ');
  }

  return (offer.badges || []).map((b) => b.text).join(' ');
};
